<template>
  <div class="container">
    <!-- <div class="flex-row">
      <div class="title">充电汽车管理系统</div>
      <div class="btn-box">
        全国
        <i style="margin:0 5px" class="el-icon-caret-bottom"></i>
      </div>
    </div> -->
    <div class="area-title">
      <div class="header"></div>
      <div class="bg" :class="isActive==1?'active':''" @click="handleActive(1)">营业额</div>
      <div class="bg" :class="isActive==2?'active':''" @click="handleActive(2)">端口数</div>
      <div class="bg" :class="isActive==3?'active':''" @click="handleActive(3)">用电量</div>
    </div>
    <div id="chart" ref="main" style="width: 100%; height: 420px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea: null,
      allData:null,
      barData:[],
      isActive:1,
      unit:'元'
    };
  },
  props:{
    level:'',
    regionId:''
  },
  mounted() {
    this.getoption1DataMoney()
    this.initChart();
    this.handleLoop();
  },
  methods: {
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
    },
    handleLoop(){
      var start = 1;
      setInterval(()=>{
        this.handleActive(start)
        start = start+1
        if(start>3){
          return start =1
        }
      },3000)
    },
    //标题背景的切换
    handleActive(val) {
      if (val == 1) {
        this.isActive = 1;
        this.unit = "元"
        this.getoption1DataMoney()
      } else if (val == 2) {
        this.isActive = 2;
        this.unit = "个"
        this.getoption1DataPort()
      }else{
        this.isActive = 3;
        this.unit = "度"
        this.getoption1DataElec()
      }
    },
    // 组件1的数据源 营业额
    getoption1DataMoney() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/turnover"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          deviceType:1,
          regionId: this.regionId,
          sortType:1,
        }),
      }).then(({ data }) => {
        console.log(data,'营业额00000')
        if (data.code == 0) {
          this.allData = data.data
          this.barData = data.data.provinceTurnoverVo;
          this.updateChart();
        }
      });
    },
    // 组件1的数据源 端口数
    getoption1DataPort() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/socket"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          deviceType:1,
          regionId: this.regionId,
          sortType:3,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.allData = data.data
          this.barData = data.data.provinceSocketVoList;
          this.updateChart();
        }
      });
    },
    // 组件1的数据源 用电量
    getoption1DataElec() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/elec"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          deviceType:1,
          regionId: this.regionId,
          sortType:2,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.allData = data.data
          this.barData = data.data.provinceElecVo;
          this.updateChart();
        }
      });
    },
    updateChart() {
      var attackSourcesColor = [
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 0, color: "#EB3B5A" },
          { offset: 1, color: "#FE9C5A" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 0, color: "#FA8231" },
          { offset: 1, color: "#FFD14C" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 0, color: "#F7B731" },
          { offset: 1, color: "#FFEE96" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 0, color: "#395CFE" },
          { offset: 1, color: "#2EC7CF" },
        ]),
      ];
      var attackSourcesColor1 = [
        "#EB3B5A",
        "#FA8231",
        "#F7B731",
        "#3860FC",
        "#1089E7",
        "#F57474",
        "#56D0E3",
        "#1089E7",
        "#F57474",
        "#1089E7",
        "#F57474",
        "#F57474",
      ];
      var newRegionNames = this.allData.regionNames;
      function contains(arr, dst) {
        var i = arr.length;
        while ((i -= 1)) {
          if (arr[i] == dst) {
            return i;
          }
        }
        return false;
      }
      function attackSourcesDataFmt(sData) {
        var sss = [];
        sData.forEach(function (item, i) {
          let itemStyle = {
            color: i > 3 ? attackSourcesColor[3] : attackSourcesColor[i],
          };
          sss.push({
            value: item.value,
            itemStyle: itemStyle,
          });
        });
        return sss;
      }

      var salvProMax = []; //背景按最大值
      for (let i = 0; i < this.barData.length; i++) {
        salvProMax.push(this.barData[0]);
      }

      const option = {
        grid: {
          left: "-20%",
          right: "0%",
          bottom: "2%",
          top: "2%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              label: {
                show: true,
                // margin: 30
              },
            },
            // pdaaing: [5, 0, 0, 0],
            // postion: "right",
            data: this.allData.regionNames,
            axisLabel: {
              margin: 30,
              fontSize: 12,
              align: "left",
              // padding: [2, 0, 0, 0],
              color: "#000",
              rich: {
                nt1: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[0],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [2, 1, 2, 1],
                  // padding:[0,0,2,0],
                },
                nt2: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[1],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [2, 1, 2, 1],
                },
                nt3: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[2],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [3, 1, 2, 1],
                },
                nt: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[3],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [3, 1, 2, 1],
                },
              },
              formatter: function (value, index) {
                index = contains(newRegionNames, value) + 1;
                if (index - 1 < 3) {
                  return ["{nt" + index + "|" + index + "}"].join("\n");
                } else {
                  return ["{nt|" + index + "}"].join("\n");
                }
              },
            },
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: "12",
              },
              formatter:  (val)=> {
                return `${val}` + this.unit;
              },
            },
            data: attackSourcesDataFmt(this.barData),
          },
          {
            //名称
            type: "category",
            offset: -10,
            position: "left",
            axisLabel: {
              color: `#00ECFC`,
              fontSize: 12,
            },
            axisLine: {
              show: false,
            },
            inverse: false,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: ["#fff"],
              align: "left",
              verticalAlign: "bottom",
              lineHeight: 24,
              fontSize: 12,
            },
            data: this.allData.regionNames.reverse(),
          },
        ],
        series: [
          {
            zlevel: 1,
            name: "",
            type: "bar",
            barWidth: "10px",
            animationDuration: 1500,
            data: attackSourcesDataFmt(this.barData),
            align: "center",
            itemStyle: {
              normal: {
                barBorderRadius: 10,
              },
            },
            label: {
              show: false,
              fontSize: 14,
              color: "#fff",
              textBorderWidth: 2,
              padding: [2, 0, 0, 0],
            },
          },
          {
            name: "",
            type: "bar",
            barWidth: 10,
            barGap: "-100%",
            barCategoryGap: "0%",
            margin: "20",
            data: salvProMax,
            textStyle: {
              //图例文字的样式
              fontSize: 14,
              color: "#fff",
            },
            itemStyle: {
              normal: {
                color: "#05325F",
                // width:"100%",
                fontSize: 14,
                barBorderRadius: 30,
              },
            },
          },
        ],
        // option结尾的大括号
      };
      this.echartArea.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.container{
  // padding-top:10px;
  padding: 10px 30px;
  position: relative;
  .flex-row{
    display: flex;
    position: absolute;
    top:-30px;
    left: 0;
    .title{
      color: #75B8FF;
      font-size: 26px;
      line-height: 30px;
    }
    .btn-box{
      width: 100px;
      height: 30px;
      border: 1px solid #0096FF;
      border-radius: 20px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      margin-left: 15px;
    }
  }
}
.area-title {
    // width: 100%;
    height: 32px;
    font-size: 14px;
    // background: url("../../assets/left-2-title.png") no-repeat;
    // background-size: 30px 20px;
    // padding-left: 40px;
    font-family: MicrosoftYaHei;
    display: flex;
    .header {
      width: 30px;
      height: 20px;
      background-image: url("../../assets/left-2-title.png");
      background-size: 30px 20px;
    }
    .bg {
      width: 110px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-image: url("../../assets/left-2-title-normal.png");
      background-size: 110px 30px;
    }
    .bg:nth-child(2) {
      margin-left: -25px;
    }
    .bg:nth-child(3){
      margin-left: -18px;
    }
    .bg:nth-child(4){
      margin-left: -18px;
    }
    .bg:hover {
      background-image: url("../../assets/left-2-title-active.png");
      background-size: 110px 30px;
      cursor: pointer;
    }
    .active {
      background-image: url("../../assets/left-2-title-active.png");
      background-size: 110px 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/car-system/option1.vue